import QuickSearchField from './QuickSearchField';

export default QuickSearchField;
